module.exports = __webpack_public_path__ + "static/media/ic_reload.680252bc.png";